var ButtonDropdown = require("components/utility/ButtonDropdown");
var ButtonDropdownOption = require("components/utility/ButtonDropdownOption");

var ComparisonsTable = require("components/data/ComparisonsTable");
var WhooosReadingClientApi = require("wr_apis/apis/wr_client_api/node_package/src/index.js")

var ProgressGraph = require("components/data/ProgressGraph");

require("appdev/screenshot_data_page.scss")

class ScreenshotDataPage extends React.Component {

	constructor(props) {
		super();
		autobind(this);

		this.state = {
			production: false, autoPrint: false, authToken: "",
			adminIDs: null, adminIDInput: "", adminIDIndex: 0, 
			studentLists: null, skillsetStandard: null,
			skillsetComparisonData: {}, progressData: {},
			view: ScreenshotDataPage.STUDENT_PROGRESS
		}

		this.apiClient = new WhooosReadingClientApi.LegacyClient()
	}

	loadIDs(e) {
		$wr.nope(e)
		var ids = this.state.adminIDInput.split(/[\t, \n]/);
		ids = _.select(ids, function(id) {
			return id == String(Number(id));
		});

		this.setState({ adminIDs: ids, adminIDIndex: -1 }, this.nextID)
	}

	updateAuthToken(token) {
		this.setState({ authToken: token });
		this.apiClient.addAuth(token);
	}

	toggleAutoPrint() {
		this.setState({ autoPrint: !this.state.autoPrint });
	}
	toggleProduction() {
		this.setState({ production: !this.state.production }, function() {
			if (this.state.production) {
				WhooosReadingClientApi.LegacyClient.setHost("api.whooosreading.org", "https");
			} else {
				WhooosReadingClientApi.LegacyClient.setHost("localhost:3002", "http");
			}
		}.bind(this));
	}

	setPageTitle() {
		window.document.title = this.currentAdminID() + "-data.pdf";
	}

	selectView(view, e) {
		$wr.nope(e)
		this.setState({ view: view });
	}

	nextID(e) {
		$wr.nope(e)
		var nextIndex = (this.state.adminIDIndex + 1);
		if (nextIndex >= this.state.adminIDs.length) { return; }

		this.setState({ adminIDIndex: nextIndex, studentLists: null,
			skillsetComparisonData: {}, progressData: {} }, function() {

			this.setPageTitle();
			this.fetchAdminData();
		}.bind(this));
	}

	currentAdminID() {
		return this.state.adminIDs[this.state.adminIDIndex];
	}

	renderProgressGrid() {
		var studentLists = _.sortBy(this.state.studentLists, function(studentList) {
			var classData = this.state.progressData[studentList.id]
			if (!classData) { return; }
			var studentQuarters = _.flatten(_.map(_.values(classData.user_results), _.values));
			var quarterCount = _.reject(studentQuarters, (q) => { return q["empty"] }).length;
			return (quarterCount / studentList.students.length) * -1;
		}.bind(this));


		return _.map(studentLists, function(studentList) {
			var classData = this.state.progressData[studentList.id];
			if (classData === undefined) { return null; }
			var students = _.sortBy(studentList.students, function(student) {
				var studentQuarters = classData.user_results[student.id];
				return _.reject(studentQuarters, (q) => { return q["empty"] }).length * -1;
			}.bind(this));
			var studentGraphs = _.map(students, function(student) {
				return (
					<div key={ student.id } className="progressWrap">
						<p className="studentName">Student: { student.display_name }</p>
						<ProgressGraph activeStudentList={ studentList }
							width={ 400 } height={ 170 } isAnimationActive={ false }
							activeStudent={ student }
							progressData={ this.state.progressData } 
							loadProgressF={ this.loadStudentListProgress }/>
					</div>
				);
			}.bind(this));

			return (
				<div key={ studentList.id }>
					<p className="studentListName">{ studentList.name }</p>
					{ studentGraphs }
				</div>
			);
		}.bind(this));
	}

	renderComparisonData() {
		var studentLists = _.sortBy(this.state.studentLists, function(studentList) {
			var classData = this.state.skillsetComparisonData[studentList.id]
			if (!classData) { return; }
			var studentSkillsets = _.flatten(_.map(_.values(classData.user_results), _.values));
			return _.reject(studentSkillsets, (q) => { return q["empty"] }).length * -1;
		}.bind(this));

		return (
			<ComparisonsTable studentLists={ studentLists } 
				comparisonData={ this.state.skillsetComparisonData }
				skillsetStandard={ this.state.skillsetStandard } expandAll={ true } />
		);
	}

	render() {

		if (this.state.adminIDs) {
			var progress = this.state.adminIDIndex / this.state.adminIDs.length;	
			var progLine = (
				<span>
					{ this.state.adminIDIndex }/{ this.state.adminIDs.length }{" "}
					({ Math.round(progress * 1000) / 10 }%)
				</span>
			);
			var actionButton = (
				<a href="#" onClick={ this.nextID }>Next</a>
			);
		} else {
			var actionButton = (
				<a href="#" onClick={ this.loadIDs }>Load</a>
			);
		}

		if (this.state.studentLists) {
			// Show student lists with the MOST interesting data first
			var studentLists = _.sortBy(this.state.studentLists, function(studentList) {
				var classData = this.state.skillsetComparisonData[studentList.id]
				if (!classData) { return; }
				var studentSkillsets = _.flatten(_.map(_.values(classData.user_results), _.values));
				return _.reject(studentSkillsets, "empty").length * -1;
			}.bind(this));

			if (this.state.view == ScreenshotDataPage.SKILLSET_COMPARISON) {
				var dataContent = this.renderComparisonData();

			} else if (this.state.view == ScreenshotDataPage.STUDENT_PROGRESS) {
				var dataContent = this.renderProgressGrid();

			}
		}

		return (
			<div className="screenshotDataPage container">

				<div className="controlSection hideOnPrint">
					<div className="headerSection">
						<header className="pageHeader">
							<h1>Screenshot Data</h1>
						</header>
					</div>

					<textarea className="adminIDs form-control" ref="adminIDs"
						onChange={ (e) => { this.setState({ adminIDInput: e.target.value }) } } />
					<div className="clearfix">
						<ButtonDropdown text={ this.state.view } dropdownDisplay="link">
							<ButtonDropdownOption text={ ScreenshotDataPage.SKILLSET_COMPARISON } 
								onClick={ this.selectView.bind(this, ScreenshotDataPage.SKILLSET_COMPARISON) } />
							<ButtonDropdownOption text={ ScreenshotDataPage.STUDENT_PROGRESS } 
								onClick={ this.selectView.bind(this, ScreenshotDataPage.STUDENT_PROGRESS) } />
						</ButtonDropdown>

						<label className="normal">
							<input type="checkbox" checked={ this.state.autoPrint }
							onChange={ this.toggleAutoPrint } /> Auto Print
						</label>{ " " }{ " " }{ " " }

						<label className="normal">
							<input type="checkbox" checked={ this.state.production }
							onChange={ this.toggleProduction } /> Production
						</label>{ " " }

						<input className="authToken" value={ this.state.authToken }
							onChange={ (e) => { this.updateAuthToken(e.target.value) } } />

						<span className="pull-right">
							{ progLine } { actionButton }
						</span>
					</div>
				</div>

				{ dataContent }
			</div>
		)
	}

	fetchAdminData() {
		var params = {
			effective_user_id: this.currentAdminID(),
			embed: "admin.student_lists,student_list.students,user.prefs"
		};

		this.apiClient.getUser(this.currentAdminID(), params, $wr.apiHandler(function(response) {
			// User.prefs may not have embed! Fix this if we want to use this again
			var skillsetStandard = response.user.prefs.skillset_standard;

			var studentLists = _.select(response.user.student_lists, function(studentList) {
				return studentList.students.length > 0;
			});

			_.each(studentLists, function(studentList) {
				_.each(studentList.students, function(student) {
					// Remove the student's names
					student.display_name = student.display_name.replace(/\w/g, "■");
				});

			});

			this.setState({ studentLists: studentLists, skillsetStandard: skillsetStandard }, function() {
				if (this.state.view == ScreenshotDataPage.SKILLSET_COMPARISON) {
					this.loadNextSkillsetAnalysis();
				} else {
					this.loadNextProgressAnalysis();
				}
			}.bind(this));
		}.bind(this)));
	}

	loadNextSkillsetAnalysis() {
		if (this._unmounted) { return; }

		var sortedStudentLists = $wr.sortByName(this.state.studentLists, "studentList");
		var nextStudentList = _.find(sortedStudentLists, function(studentList) {
			return !_.has(this.state.skillsetComparisonData, studentList.id);
		}.bind(this));

		if (!nextStudentList) {
			if (this.state.autoPrint) {
				window.print()
				this.nextID();
			}
			return;
		}

		var params = {
			student_list_id: nextStudentList.id, effective_user_id: this.currentAdminID()
		}
		this.apiClient.getAnalyzeSkillsets(params, $wr.apiHandler(function(response) {
			var newComparisonData = _.clone(this.state.skillsetComparisonData);
			newComparisonData[nextStudentList.id] = response.results;
			this.setState({ skillsetComparisonData: newComparisonData }, this.loadNextSkillsetAnalysis);
		}.bind(this)));
	}

	loadNextProgressAnalysis() {
		if (this._unmounted) { return; }

		var sortedStudentLists = $wr.sortByName(this.state.studentLists, "studentList");
		var nextStudentList = _.find(sortedStudentLists, function(studentList) {
			return !_.has(this.state.progressData, studentList.id);
		}.bind(this));

		if (!nextStudentList) {
			if (this.state.autoPrint) {
				setTimeout(function() {
					window.print()
					this.nextID();
				}.bind(this), 300);
			}
			return;
		}

		var params = {
			student_list_id: nextStudentList.id, effective_user_id: this.currentAdminID()
		};

		this.apiClient.getAnalyzeProgress(params, $wr.apiHandler(function(response) {
			var newProgressData = _.clone(this.state.progressData);
			newProgressData[nextStudentList.id] = response.results;
			this.setState({ progressData: newProgressData }, this.loadNextProgressAnalysis);
		}.bind(this)));
	}

};

ScreenshotDataPage.propTypes = PageStrictPropTypes({
});

ScreenshotDataPage.SKILLSET_COMPARISON = "Skillset Comparison";
ScreenshotDataPage.STUDENT_PROGRESS = "Student Progress";

module.exports = ScreenshotDataPage;


// WEBPACK FOOTER //
// ./modules/components/appdev/ScreenshotDataPage.js